import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '@/views/Home/index.vue';
import Demo from '@/views/Demo/index.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/demo',
    name: 'Demo',
    component: Demo,
  },
];

const router = new VueRouter({
  mode: 'hash', // 使用 hash 模式（推荐用于 webview 中）
  routes,
});

export default router;
